import { type FC } from 'react'
import classnames from 'classnames'
import { Tooltip, type ITooltipProps } from 'shared/ui/Tooltip'
import styles from './styles.module.scss'

type IProgressBarProps = {
  percent: number
  withAllBorders?: boolean
  withBg?: boolean
  className?: string
  tooltipProps?: ITooltipProps
}

export const ProgressBar: FC<IProgressBarProps> = ({
  percent,
  withAllBorders,
  withBg,
  className,
  tooltipProps,
}) => {
  const progressBar = (
    <div
      className={classnames(styles.wrap, className, {
        [styles.withBg]: withBg,
        [styles.allBorders]: withAllBorders,
      })}
    >
      <div className={styles.progress} style={{ width: `${percent}%` }} />
    </div>
  )

  if (tooltipProps) {
    return (
      <Tooltip fullWidth {...tooltipProps}>
        {progressBar}
      </Tooltip>
    )
  }

  return progressBar
}
